// Libraries
var React = require('react');
var $ = require('jquery');

// Styles
require('./Lineup.scss');

// Components
var LineupPlayer = require('./LineupPlayer');

// Assets
var spinner = require('../../../common/images/Rolling.svg');

class LineupModule extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {},
            highlights: [],
            highlightsToRemove: [],
            isLoading: true
        };

        this.highlightsEndpoint = this.props.data.endpoints.find(x => x.name === "highlights");
    }

    componentDidMount() {
        // delay the load of the realtime library until it's reached the browser 
        // to avoid server side rendering errors
        this.Realtime = require('../../../common/Realtime/Realtime');

        this.loadLineup();
        this.attachChannels();
        this.loadHighlights();
    }

    timestampSort = (a, b) => new Date(a.TimestampIsoFormat) - new Date(b.TimestampIsoFormat);

    parseHighlights = events => [...events].sort(this.timestampSort)

    handleHighlights = (data, hasPriority) => {
        console.log("handleHighlights:", data, " priority: ", hasPriority);
        
        if (!hasPriority && this.state.highlightsToRemove.length > 0) {
            // case when subscription response came first than initial ajax
            const isDeleted = event =>
                this.state.highlightsToRemove
                    .findIndex(item => item.Id === event.Id) !== -1;

            const isDuplicate = event =>
                this.state.highlights
                    .findIndex(item => item.Id === event.Id) !== -1;

            const highlights = this.parseHighlights([
                ...this.state.highlights,
                ...data[data.Items ? 'Items' : 'Updated'].filter(x => !isDeleted(x)).filter(x => !isDuplicate(x))
            ]);

            this.setState({
                highlights: highlights ? highlights : [],
                highlightsToRemove: []
            });

        } else {
            if (hasPriority && this.state.highlights.length <= 0) {
                // when subscription response came first - keep items for deleting in state and apply it for ajax response later
                this.setState({
                    highlightsToRemove: data.Deleted ? data.Deleted : []
                });
            }

            const isDeleted = event => data.Deleted && data.Deleted.findIndex(item => item.Id === event.Id) !== -1;
            const isDuplicate = event =>
			    data[data.Items ? 'Items' : 'Updated']
                    .findIndex(item => item.Id === event.Id) !== -1;
       
            const highlights = this.parseHighlights([
                ...data[data.Items ? 'Items' : 'Updated'],
                ...this.state.highlights.filter(x => !isDeleted(x)).filter(x => !isDuplicate(x))
            ]);
            this.setState({
                highlights: highlights ? highlights : []
            });
        }

        console.log("final list: ", this.state.highlights);
    }

    loadHighlights = () => {
		$.ajax({
			method: "GET", 
			url: this.highlightsEndpoint.url
		})
        .done(data => {
		    this.handleHighlights(data, false);
		});
	}

    loadLineup = () => {
        $.ajax({
            method: "GET", 
            url: this.props.data.endpoints.find(x => x.name === "lineup").url
        })
        .done(data => {
            this.populateLineup(data);
        })
        .fail(() => {
            this.setState({ isLoading: false });
        });
    };

    populateLineup = (data) => {

			let fixtureId = this.props.data.endpoints.find(x => x.name === "lineup").channelId.match(/\.(.+)$/)[1];

			data.HomeTeamDetails.StartingLineUp.map((item) => {
				item.statsUrl = this.props.data.baseUrl + "mdc/playerprofile?playerId=" + item.PlayerId + "&id=" + fixtureId;
				return item;
			});

			data.HomeTeamDetails.Substitutes.map((item) => {
				item.statsUrl = this.props.data.baseUrl + "mdc/playerprofile?playerId=" + item.PlayerId + "&id=" + fixtureId;
				return item;
			});

			data.AwayTeamDetails.StartingLineUp.map((item) => {
				item.statsUrl = this.props.data.baseUrl + "mdc/playerprofile?playerId=" + item.PlayerId + "&id=" + fixtureId;
				return item;
			});

			data.AwayTeamDetails.Substitutes.map((item) => {
				item.statsUrl = this.props.data.baseUrl + "mdc/playerprofile?playerId=" + item.PlayerId + "&id=" + fixtureId;
				return item;
			});

        this.setState({data: data, isLoading: false});
    };

    attachChannels = () => {
        let lineupChannel = this.props.data.endpoints.find(x => x.name === "lineup").channelId;

        this.Realtime.subscribe(lineupChannel, this.props.data.realtimeKey, (message) => {
            this.populateLineup(message.data);
        });

        this.Realtime.subscribe(this.highlightsEndpoint.channelId, this.props.data.realtimeKey, message => {
            console.log("LineupModule : subscribed highlights message: ", message.data);
            if (message.data) {
                this.handleHighlights(message.data, true);
            }
        });
    };
    
	render() {
        let isHomeData = this.state.data && this.state.data.HomeTeamDetails && this.state.data.HomeTeamDetails.StartingLineUp.length > 0;
        let isAwayData = this.state.data && this.state.data.AwayTeamDetails && this.state.data.AwayTeamDetails.StartingLineUp.length > 0;

        return (
            <div className="Lineup">
                <div className="Lineup__wrapper">
                    <h2>Line-up</h2>

                    {(isHomeData || isAwayData) && this.props.data.description &&
                        <p>{this.props.data.description}</p>                    
                    }

                    {isHomeData &&
                        <div className="Lineup__column">
                            <div className="Lineup__header" tabIndex="0">
                                <div className="Lineup__crest">
                                    <img src={this.props.data.baseUrl + this.state.data.HomeTeamDetails.CrestUrl} alt="Crest logo" />
                                </div>
                                <div className="Lineup__title">
                                    <p>{this.state.data.HomeTeamDetails.Name}</p>
                                </div>
                            </div>
                            <div className="Lineup__group">
                                {this.state.data.HomeTeamDetails.StartingLineUp.map((item, index) => {
                                    return <LineupPlayer key={index} player={item} highlights={this.state.highlights} />
                                })}
                            </div>
                            <div className="Lineup__group">
                                <p className="Lineup__subheader">Substitutes</p>
                                {this.state.data.HomeTeamDetails.Substitutes.map((item, index) => {
                                    return <LineupPlayer key={index} player={item} highlights={this.state.highlights} />
                                })}
                            </div>
                        </div>
                    }
                    
                    {isAwayData &&
                        <div className="Lineup__column">
                            <div className="Lineup__header" tabIndex="0">
                                <div className="Lineup__crest">
                                    <img src={this.props.data.baseUrl + this.state.data.AwayTeamDetails.CrestUrl} alt="Crest logo" />
                                </div>
                                <div className="Lineup__title">
                                    <p>{this.state.data.AwayTeamDetails.Name}</p>
                                </div>
                            </div>
                            <div className="Lineup__group">
                                {this.state.data.AwayTeamDetails.StartingLineUp.map((item, index) => {
                                    return <LineupPlayer key={index} player={item} highlights={this.state.highlights} />
                                })}
                            </div>
                            <div className="Lineup__group">
                                <p className="Lineup__subheader">Substitutes</p>
                                {this.state.data.AwayTeamDetails.Substitutes.map((item, index) => {
                                    return <LineupPlayer key={index} player={item} highlights={this.state.highlights} />
                                })}
                            </div>
                        </div>
                    }

                    {this.state.isLoading &&
                        <img src={spinner} className="spinner" alt="Loading animation" />
                    }

                    {!this.state.isLoading && !isHomeData && !isAwayData &&
                        <p>Line-ups will show on this page in the build-up to kick-off.</p>
                    }

                </div>
            </div>
		)
	}
}

module.exports = LineupModule;



// WEBPACK FOOTER //
// ./src/components/MDC/Lineup/LineupModule.js